{
  "ddd, MMM D, YYYY": "ddd, D MMM YYYY",
  "h:mm A z": "h:mm a z",
  "Video fragment {number}": "Fragmento de video {number}",
  "Upload to Beginning": "Subir al principio",
  "Upload to End": "Subir al final",
  "Replace All Video": "Reemplazar todo el video",
  "Total length: {duration}": "Duración total: {duration}",
  "Upload After": "Subir después de este",
  "Delete this uploaded video?": "¿Eliminar este video subido?",
  "Delete this video fragment?": "¿Eliminar este fragmento de video?",
  "Video fragment deleted": "Fragmento de video eliminado",
  "Could not delete video fragment": "No se pudo eliminar el fragmento de video",
  "Loading event video...": "Cargando el video del evento...",
  "Deleting video fragment...": "Eliminando el fragmento de video...",
  "Loading uploaded video fragments...": "Cargando los fragmentos de video subidos...",
  "Could not finish upload": "No se pudo terminar la subida",
  "Could not queue video conversion": "No se pudo poner en cola la conversión del video",
  "Event video is uploaded and will be processed now": "El video del evento se subió y ahora se procesará",
  "Upload an edited or backup recording of the live stream. This will replace the current video on event page.": "Sube una grabación editada o de respaldo de la transmisión en vivo. Reemplazará el video actual de la página del evento.",
  "Upload video to event page. Video will show on event page before Live Stream starts. Once you go Live, the live stream will replace the uploaded video automatically": "Sube un video a la página del evento. Se mostrará en la página del evento antes de que empiece la transmisión en vivo. Cuando transmitas en vivo, la transmisión reemplazará automáticamente el video subido",
  "Delete Uploaded Video?": "¿Eliminar el video subido?",
  "Notify all guests when it's uploaded": "Avisar a todos los invitados cuando se haya subido",
  "Permission to Access Photo Library Necessary": "Se necesita permiso para acceder a tus fotos",
  "Could not access selected video.": "No se pudo acceder al video seleccionado.",
  "Could not open the video.": "No se pudo abrir el video.",
  "This video may still be in iCloud. Open Photos, download it to this iPhone, and try again.": "Puede que este video siga en iCloud. Abre Fotos, descárgalo en este iPhone e inténtalo de nuevo.",
  "Please try again, or choose another video.": "Inténtalo de nuevo o elige otro video.",
  "Could not open video library.": "No se pudo abrir la biblioteca de videos.",
  "Please check if permissions are given": "Revisa que la app tenga permiso",
  "Could not start video upload.": "No se pudo iniciar la subida del video.",
  "Please try another video or check photo permissions in iOS Settings.": "Prueba con otro video o revisa los permisos de fotos en Configuración de iOS.",
  "Only mov or mp4 files are accepted": "Solo se aceptan archivos mov o mp4",
  "Cancel this upload?": "¿Cancelar esta subida?",
  "The part already uploaded will be discarded.": "Se descartará la parte que ya se subió.",
  "Cancel upload": "Cancelar subida",
  "Keep uploading": "Seguir subiendo",
  "{loaded} from {total}": "{loaded} de {total}",
  "Uploading...": "Subiendo...",
  "Video Uploaded": "Video subido",
  "Converting Video. This may take a few minutes.": "Convirtiendo el video. Puede tardar unos minutos.",
  "Replace live video": "Reemplazar el video de la transmisión",
  "MOV or MP4 video. 10GB Max.": "Video MOV o MP4. Máx. 10 GB.",
  "Failed to start upload": "No se pudo iniciar la subida",
  "Trim the video": "Recortar el video",
  "trim|From": "Desde",
  "Enter start time in hh:mm:ss format if you want to clip the beginning of the video. For example, if you want to start the video 20 minutes into the live stream, enter \"00:20:00\"": "Si quieres recortar el inicio del video, escribe el tiempo de inicio en formato hh:mm:ss. Por ejemplo, para que el video empiece a los 20 minutos de la transmisión en vivo, escribe \"00:20:00\"",
  "MOV or MP4 video. Up to 200 GB.": "Video MOV o MP4. Hasta 200 GB.",
  "upload status|converted": "convertido",
  "upload status|converting": "en conversión",
  "upload status|waiting to convert": "esperando la conversión",
  "This video was already uploaded for this event (status: {status}).": "Este video ya se subió a este evento (estado: {status}).",
  "{part} of {total} {unit}": "{part} de {total} {unit}",
  "Resuming — {sizes} were already uploaded": "Reanudando: ya se habían subido {sizes}",
  "Starting over — nothing had finished uploading yet": "Empezando de nuevo: todavía no se había terminado de subir nada",
  "under a minute left": "queda menos de un minuto",
  "about {count} min left": {
    "one": "queda alrededor de {count} min",
    "other": "quedan unos {count} min"
  },
  "about {count} h {minutes} min left": {
    "one": "queda alrededor de {count} h {minutes} min",
    "other": "quedan unas {count} h {minutes} min"
  },
  "about {count} h left": {
    "one": "queda alrededor de {count} h",
    "other": "quedan unas {count} h"
  },
  "Pause": "Pausar",
  "Resume": "Reanudar",
  "Upload again": "Subir de nuevo",
  "upload card|View event page": "Ver la página",
  "You can leave this page meanwhile.": "Mientras tanto, puedes salir de esta página.",
  "Processing starting soon": "El procesamiento empezará pronto",
  "We're finishing other videos first. You can leave this page meanwhile.": "Primero estamos terminando otros videos. Mientras tanto, puedes salir de esta página.",
  "Waiting for processing…": "Esperando el procesamiento…",
  "Preparing your video…": "Preparando tu video…",
  "Publishing to your event page…": "Publicando en la página de tu evento…",
  "Almost done.": "Ya casi terminamos.",
  "Still processing…": "Aún se está procesando…",
  "Processing video… {percent}%": "Procesando video… {percent}%",
  "Uploading video": "Subiendo video",
  "Waiting for network…": "Esperando conexión…",
  "Starting the upload…": "Iniciando la subida…",
  "Calculating time left…": "Calculando el tiempo restante…",
  "Paused": "En pausa",
  "The upload continues where it stopped.": "La subida continuará desde donde se detuvo.",
  "Finishing upload…": "Terminando la subida…",
  "Putting the video together.": "Uniendo las partes del video.",
  "{size} uploaded": "{size} subidos",
  "Your video is ready": "Tu video está listo",
  "It's on your event page now.": "Ya está en la página de tu evento.",
  "Upload interrupted": "Subida interrumpida",
  "Already uploaded": "Ya se subió",
  "Upload cancelled": "Subida cancelada",
  "This upload was cancelled. The event's video hasn't changed.": "Se canceló esta subida. El video del evento no cambió.",
  "Could not open the video. Please try again.": "No se pudo abrir el video. Inténtalo de nuevo.",
  "Discard this unfinished upload?": "¿Descartar esta subida sin terminar?",
  "The part already uploaded will be deleted.": "Se eliminará la parte que ya se subió.",
  "Discard upload": "Descartar subida",
  "upload|Keep it": "Conservarla",
  "It replaces the event's video.": "Reemplaza el video del evento.",
  "It goes at the end of the event's video.": "Va al final del video del evento.",
  "It goes at the beginning of the event's video.": "Va al principio del video del evento.",
  "It goes between the event's video fragments.": "Va entre los fragmentos del video del evento.",
  "Try again, or upload it again.": "Inténtalo de nuevo o vuelve a subirlo.",
  "Please upload it again.": "Vuelve a subirlo.",
  "We couldn't process your video": "No pudimos procesar tu video",
  "“{filename}” was uploaded but couldn't be converted.": "“{filename}” se subió, pero no se pudo convertir.",
  "The video was uploaded but couldn't be converted.": "El video se subió, pero no se pudo convertir.",
  "If it keeps happening, contact support.": "Si sigue pasando, contacta con soporte.",
  "Trying again…": "Reintentando…",
  "Try again →": "Intentar de nuevo →",
  "Contact support →": "Contactar con soporte →",
  "notice|Dismiss": "Cerrar",
  "Unfinished upload": "Subida sin terminar",
  "“{filename}” ({size}), {percent}% uploaded.": "“{filename}” ({size}), subido al {percent}%.",
  "Choose the same file to continue where the upload stopped.": "Elige el mismo archivo para continuar donde se detuvo la subida.",
  "Resume upload →": "Reanudar subida →",
  "Discard": "Descartar",
  "Photo Library": "Fototeca",
  "Files": "Archivos",
  "Choose a video": "Elige un video",
  "Your event is live. Upload after the stream ends.": "Tu evento está en vivo. Sube el video cuando termine la transmisión.",
  "This event no longer exists.": "Este evento ya no existe.",
  "You don't have access to upload video to this event.": "No tienes permiso para subir videos a este evento.",
  "This upload has expired. Please choose the file again.": "Esta subida expiró. Vuelve a elegir el archivo.",
  "This upload has already finished or was cancelled.": "Esta subida ya terminó o se canceló.",
  "Some parts of the video haven't uploaded yet.": "Algunas partes del video aún no se han subido.",
  "The uploaded video doesn't match the file. Please upload it again.": "El video subido no coincide con el archivo. Vuelve a subirlo.",
  "This video was already uploaded for this event.": "Este video ya se subió a este evento.",
  "Too many uploads are in progress. Finish or cancel one, then try again.": "Hay demasiadas subidas en curso. Termina o cancela una e inténtalo de nuevo.",
  "This file is too large. Videos can be up to 200 GB.": "Este archivo es demasiado grande. Los videos pueden tener hasta 200 GB.",
  "This file is empty. Please choose another video.": "Este archivo está vacío. Elige otro video.",
  "Please choose a video file (MP4 or MOV).": "Elige un archivo de video (MP4 o MOV).",
  "This upload couldn't be started. Please choose the file again.": "No se pudo iniciar esta subida. Vuelve a elegir el archivo.",
  "Video upload is temporarily unavailable. Please try again later.": "La subida de videos no está disponible temporalmente. Inténtalo más tarde.",
  "Something went wrong on our side. Please try again.": "Algo salió mal por nuestra parte. Inténtalo de nuevo.",
  "This video can't be converted again. Please upload it again.": "Este video no se puede volver a convertir. Vuelve a subirlo.",
  "This upload is no longer available. Please choose the file again.": "Esta subida ya no está disponible. Vuelve a elegir el archivo.",
  "This upload can't continue. Please choose the file again.": "Esta subida no puede continuar. Vuelve a elegir el archivo.",
  "This file can't be uploaded. Please choose another video.": "Este archivo no se puede subir. Elige otro video.",
  "Too many uploads at once. Please wait a moment and try again.": "Demasiadas subidas a la vez. Espera un momento e inténtalo de nuevo.",
  "Could not reach the upload service. Check your internet connection and try again.": "No se pudo conectar con el servicio de subida. Revisa tu conexión a internet e inténtalo de nuevo.",
  "The upload was interrupted. Check your internet connection and try again.": "La subida se interrumpió. Revisa tu conexión a internet e inténtalo de nuevo.",
  "This upload doesn't match the file. Please choose the file again.": "Esta subida no coincide con el archivo. Vuelve a elegir el archivo.",
  "Could not finish the upload. Please try again.": "No se pudo terminar la subida. Inténtalo de nuevo.",
  "Could not read the video file. Please choose it again.": "No se pudo leer el archivo de video. Vuelve a elegirlo.",
  "Another upload for this event is still in progress.": "Todavía hay otra subida en curso para este evento.",
  "There's no upload to continue.": "No hay ninguna subida que continuar.",
  "Could not start the conversion again. Please try again later.": "No se pudo reiniciar la conversión. Inténtalo más tarde.",
  "Choose the file again to continue the upload.": "Vuelve a elegir el archivo para continuar la subida.",
  "That's a different file. Choose “{name}” to continue this upload.": "Es un archivo distinto. Elige “{name}” para continuar esta subida.",
  "Choose a video file.": "Elige un archivo de video.",
  "There isn't enough free space on this device to continue the upload. Free up some space, then try again.": "No hay espacio suficiente en este dispositivo para seguir subiendo. Libera espacio e inténtalo de nuevo.",
  "This upload was cancelled.": "Se canceló esta subida.",
  "Upload failed": "Error al subir",
  "Upload File": "Subir archivo",
  "File uploaded": "Archivo subido",
  "Guest list saved to Files": "Lista de invitados guardada en Archivos",
  "Downloads > {filename}": "Descargas > {filename}",
  "Files > On my iPhone > EventLive > {filename}": "Archivos > En mi iPhone > EventLive > {filename}",
  "Could not save the file.": "No se pudo guardar el archivo.",
  "Please try again on web": "Inténtalo de nuevo desde la web"
}
